import { DeepPartial, InstallWaterHeaterPackage } from 'types';

import { api } from './api';

export const installWaterHeaterPackageApi = api.injectEndpoints({
  endpoints: (build) => ({
    saveInstallWaterHeaterPackage: build.mutation<
      any,
      { accountId: string; savePackage: DeepPartial<InstallWaterHeaterPackage> }
    >({
      query: ({ accountId, savePackage }) => ({
        url: `v2/accounts/${accountId}/install-package/water-heater/save`,
        method: 'POST',
        body: { ...savePackage },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'SystemDesign', id: arg?.accountId },
      ],
    }),
    submitInstallWaterHeaterPackage: build.mutation<
      any,
      { accountId: string; installPackage: InstallWaterHeaterPackage }
    >({
      query: ({ accountId, installPackage }) => ({
        url: `v2/accounts/${accountId}/install-package/water-heater/submit`,
        method: 'POST',
        body: { ...installPackage },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'Queues', accountId: arg?.accountId },
        { type: 'SystemDesign', id: arg?.accountId },
        { type: 'AccountMilestones', id: arg?.accountId },
      ],
    }),
  }),
});

export const { useSaveInstallWaterHeaterPackageMutation, useSubmitInstallWaterHeaterPackageMutation } =
  installWaterHeaterPackageApi;
